import React from "react"
import { withRouteData, Link } from "react-static"
import List from "./list"
import Map from "../../components/Map"
import { getParams } from "utils"
import "./styles.css"
import { setParams, clearParams } from "../../utils"

const datasetsPerPage = 12

const temporalPresets = [
	{
		label: "--- Temporal Interval ---",
		value: "-"
	},
	{
		label: "African Humid Period",
		value: "11500-5000"
	},
	{
		label: "Ahmarian",
		value: "38000-25000"
	},
	{
		label: "Allerød",
		value: "14000-13000"
	},
	{
		label: "Aurignacian",
		value: "43000-31000"
	},
	{
		label: "Azilian",
		value: "14300-11600"
	},
	{
		label: "Badegoulian",
		value: "23000-20000"
	},
	{
		label: "Boreal",
		value: "8690-7270"
	},
	{
		label: "Bronze Age",
		value: "4200-2800"
	},
	{
		label: "Bølling",
		value: "14670-14100"
	},
	{
		label: "Chalcolithic (southeast europe)",
		value: "7500-5300"
	},
	{
		label: "Chatelperronian",
		value: "45000-40000"
	},
	{
		label: "Dabban",
		value: "40000-14000"
	},
	{
		label: "Early Mesolithic",
		value: "11600-9000"
	},
	{
		label: "Early Neolithic",
		value: "7600-6000"
	},
	{
		label: "Early Weichselian",
		value: "115000-60000"
	},
	{
		label: "Eemian",
		value: "130000-115000"
	},
	{
		label: "Emirian  MPUP Transition",
		value: "50000-42000"
	},
	{
		label: "Epigravettian",
		value: "22000-12000"
	},
	{
		label: "Epipalaeolithic",
		value: "11500-7000"
	},
	{
		label: "Epipalaeolithic geometric",
		value: "8700-5400"
	},
	{
		label: "Epipalaeolithic in transition",
		value: "7600-6000"
	},
	{
		label: "Epipalaeolithic laminar",
		value: "10300-8700"
	},
	{
		label: "FedermesserGruppen",
		value: "14000-12800"
	},
	{
		label: "Final Neolithic",
		value: "4800-4200"
	},
	{
		label: "Gravettian",
		value: "35000-24000"
	},
	{
		label: "Hamburgian",
		value: "15500-13600"
	},
	{
		label: "Holocene",
		value: "13650-0"
	},
	{
		label: "Ibéromaurusienne",
		value: "20000-10000"
	},
	{
		label: "Initial Upper Palaeolithic",
		value: "45000-38000"
	},
	{
		label: "Ionian",
		value: "781000-126000"
	},
	{
		label: "Kebarian",
		value: "20000-14500"
	},
	{
		label: "Last 45000 years",
		value: "45000-0"
	},
	{
		label: "Last Glacial Maximum",
		value: "26500-19000"
	},
	{
		label: "Late Glacial",
		value: "17000-10000"
	},
	{
		label: "Late Mesolithic",
		value: "9000-7000"
	},
	{
		label: "Late Neolithic",
		value: "6000-4800"
	},
	{
		label: "Late Pleistocene",
		value: "126000-11700"
	},
	{
		label: "Late Quaternary",
		value: "500000-0"
	},
	{
		label: "Late Saalian",
		value: "160000-130000"
	},
	{
		label: "Late Weichselian",
		value: "14500-12000"
	},
	{
		label: "Leaf Point Complex",
		value: "45000-40000"
	},
	{
		label: "Levantine Aurignacian",
		value: "32000-26000"
	},
	{
		label: "Little Ice Age",
		value: "700-150"
	},
	{
		label: "MIS 1",
		value: "14000-0"
	},
	{
		label: "MIS 1 to MIS 5",
		value: "130000-0"
	},
	{
		label: "MIS 2",
		value: "29000-15000"
	},
	{
		label: "MIS 3",
		value: "57000-30000"
	},
	{
		label: "MIS 4",
		value: "71000-58000"
	},
	{
		label: "MIS 5",
		value: "130000-72000"
	},
	{
		label: "MIS 6",
		value: "191000-124000"
	},
	{
		label: "Magdalenian",
		value: "18000-12000"
	},
	{
		label: "Masraqqan",
		value: "22000-20000"
	},
	{
		label: "Medieval Warm Period",
		value: "1050-750"
	},
	{
		label: "Mesolithic",
		value: "11600-7000"
	},
	{
		label: "Metal Ages",
		value: "5300-1000"
	},
	{
		label: "Micoquian",
		value: "60000-40000"
	},
	{
		label: "Middle Neolithic",
		value: "6900-6300"
	},
	{
		label: "Middle Palaeolithic",
		value: "300000-40000"
	},
	{
		label: "Middle Palaeolithic of Aterian Type MPAT",
		value: "145000-44000"
	},
	{
		label: "Middle Pleistocene",
		value: "781000-126000"
	},
	{
		label: "Middle Stone Age",
		value: "280000-50000"
	},
	{
		label: "Middle Weichselian",
		value: "60000-50000"
	},
	{
		label: "Miocene",
		value: "23030000-5333000"
	},
	{
		label: "Natufian",
		value: "12800-10200"
	},
	{
		label: "Neolithic",
		value: "10500-4200"
	},
	{
		label: "Older Dryas",
		value: "14050-13900"
	},
	{
		label: "Oldest Dryas",
		value: "16050-13050"
	},
	{
		label: "PPNA",
		value: "10500-9200"
	},
	{
		label: "PPNB",
		value: "9500-7900"
	},
	{
		label: "PPNC",
		value: "7900-7500"
	},
	{
		label: "Paleolithic",
		value: "3300000-10000"
	},
	{
		label: "Pleistocene",
		value: "2580000-11700"
	},
	{
		label: "Pottery Neolithic",
		value: "8000-6100"
	},
	{
		label: "Protoaurignacien",
		value: "39000-34000"
	},
	{
		label: "Quaternary",
		value: "2580000-0"
	},
	{
		label: "Roman Warm Period",
		value: "2250-1600"
	},
	{
		label: "Solutrean",
		value: "26000-18500"
	},
	{
		label: "Tarantian",
		value: "128000-11650"
	},
	{
		label: "Uluzzian",
		value: "45000-39000"
	},
	{
		label: "Upper Palaeolithic",
		value: "45000-12000"
	},
	{
		label: "Weichselian",
		value: "115000-11700"
	},
	{
		label: "Weichselian High Glacial",
		value: "59000-17000"
	},
	{
		label: "Younger Dryas",
		value: "12900-11700"
	}
]

class Datasets extends React.Component {
	constructor(props) {
		super(props)

		const datasetOffset = (props.page - 1) * datasetsPerPage
		this.state = {
			mode: props.mode || "dataset",
			datasets: this.props.datasets.slice(0, datasetsPerPage),
			sort: "metadata_created",
			filters: {},
			tagSearch: "",
			page: 1
		}
	}

	componentDidMount() {
		const params = getParams()
		const paramkeys = Object.keys(params)
		const filters = paramkeys.reduce(
			(filters, key) => ({
				...filters,
				[key]: decodeURIComponent(params[key])
			}),
			{}
		)

		if (paramkeys.length > 0) {
			this.setState({ filters })
		}
	}

	filterCallback = dataset => {
		const { filters } = this.state
		let keepDataset = true

		if ("project" in filters) {
			keepDataset =
				keepDataset &&
				dataset.groups
					.toLowerCase()
					.includes(filters.project.toLowerCase())
		}

		if ("doi" in filters) {
			keepDataset =
				keepDataset &&
				dataset.bibtex_doi &&
				dataset.bibtex_doi.trim().length > 0
		}

		if ("sfb806doi" in filters) {
			keepDataset =
				keepDataset &&
				dataset.bibtex_doi &&
				dataset.bibtex_doi.startsWith("10.5880/")
		}

		if ("temporal" in filters) {
			keepDataset = keepDataset && dataset.hasTemporal
		}

		if ("temporal-start" in filters && "temporal-end" in filters) {
			keepDataset =
				keepDataset &&
				dataset.hasTemporal &&
				dataset.temporals.find(
					t =>
						t.sortEnd / -10000000000 <= filters["temporal-start"] &&
						t.sortStart / -10000000000 >= filters["temporal-end"]
				)
		}

		if ("spatial" in filters) {
			keepDataset = keepDataset && dataset.hasSpatial

			if (typeof filters.spatial === "string") {
				const { x1, x2, y1, y2 } = JSON.parse(filters.spatial)
				keepDataset =
					keepDataset &&
					((dataset.spatial_x1 >= parseFloat(x1) &&
						dataset.spatial_x2 <= parseFloat(x2)) ||
						(dataset.spatial_x2 >= parseFloat(x1) &&
							dataset.spatial_x2 <= parseFloat(x2))) &&
					((dataset.spatial_y1 >= parseFloat(y1) &&
						dataset.spatial_y1 <= parseFloat(y2)) ||
						(dataset.spatial_y2 >= parseFloat(y1) &&
							dataset.spatial_y2 <= parseFloat(y2)))
			}
		}

		if ("paleomaps" in filters) {
			keepDataset = keepDataset && dataset.paleo_map === "1"
		}

		if ("tag" in filters) {
			keepDataset = keepDataset && dataset.tags.includes(filters.tag)
		}

		if ("peerreviewed" in filters) {
			keepDataset =
				keepDataset &&
				(filters.peerreviewed === "ISI-indexed"
					? dataset.publicationstate === "peerreviewed_isiindexed"
					: typeof dataset.publicationstate === "string")
		}

		return keepDataset
	}

	sortCallback = (a, b) => {
		const sort = this.state ? this.state.sort : ""
		let compare = (a, b) =>
			new Date(b.metadata_created).getTime() -
			new Date(a.metadata_created).getTime()
		if (sort === "bibtex_year")
			compare = (a, b) => {
				if (a.bibtex_year.length > 0 && b.bibtex_year.length === 0)
					return -1
				else if (a.bibtex_year.length === 0 && b.bibtex_year.length > 0)
					return 1
				else if (a.bibtex_year.length > 0 && b.bibtex_year > 0)
					return parseInt(b.bibtex_year) - parseInt(a.bibtex_year)
				return 0
			}
		else if (sort === "maintainers")
			compare = (a, b) =>
				a.maintainers[0] == b.maintainers[0]
					? 0
					: a.maintainers[0] < b.maintainers[0]
					? -1
					: 1
		else if (sort === "title")
			compare = (a, b) =>
				a.title[0] == b.title[0] ? 0 : a.title[0] < b.title[0] ? -1 : 1

		return compare(a, b)
	}

	toggleFilter = (key, value) => {
		const { filters } = this.state

		// Remove regular doi filter if sfb806 filter is active and vice versa
		if (key === "sfb806doi" && "doi" in filters) {
			delete filters["doi"]
		}
		if (key === "doi" && "sfb806doi" in filters) {
			delete filters["sfb806doi"]
		}

		// Add/Update if value is new, remove if value is the same
		if (key in filters && filters[key] === value) {
			delete filters[key]
		} else {
			filters[key] = value
		}

		setParams(filters)
		this.setState({ filters, page: 1 })
	}

	removeFilter = key => {
		const { filters } = this.state
		if (key in filters) {
			delete filters[key]
			this.setState({ filters, page: 1 })
			return true
		}

		return false
	}

	clearFilter = () => {
		clearParams()
		this.setState({ filters: {} })
	}

	getCurrentDatasets = () =>
		this.props.datasets.sort(this.sortCallback).filter(this.filterCallback)

	getPagination = () =>
		Array.from(
			new Array(
				Math.floor(this.getCurrentDatasets().length / datasetsPerPage)
			)
		).map((item, index) => index + 1)

	render() {
		const tags = this.props.tags || []
		const { filters, tagSearch } = this.state
		const projectCounts = []
		const currentDatasets = this.getCurrentDatasets()
		;(this.props.datasets || []).forEach(d => {
			// d.groups.split(';').map(group => group[0].toUpperCase())
			projectCounts[d.groups.toUpperCase()[0]] =
				projectCounts[d.groups.toUpperCase()[0]] === undefined
					? 1
					: projectCounts[d.groups.toUpperCase()[0]] + 1
		})

		return (
			<div id="datasets" className="grid-content">
				<div id="datasets-list-container" className="card narrow">
					<h1>
						{this.props.mode === "dataset"
							? "Datasets"
							: "Publications"}
					</h1>
					<div id="datasets-list-meta">
						{currentDatasets.length} Items found
						{Object.keys(filters).length > 0 && (
							<span
								id="filter-container"
								onClick={this.clearFilter}
							>
								, Filter{Object.keys(filters).length > 1 && "s"}
								{": "}
								{Object.keys(filters).map(filter => (
									<span
										key={filter}
										className="active-filter"
									>
										{filter}
										{typeof filters[filter] === "string" &&
											`(${filters[filter]})`}
									</span>
								))}
							</span>
						)}
					</div>

					<List
						datasets={currentDatasets.slice(
							(this.state.page - 1) * datasetsPerPage,
							this.state.page * datasetsPerPage
						)}
						mode={this.state.mode}
					/>

					<ul className="pagination">
						{this.getPagination().map(index => (
							<li
								key={`page-${index}`}
								className={
									this.state.page === index ? "active" : ""
								}
								onClick={() => this.setState({ page: index })}
							>
								{index}
							</li>
						))}
					</ul>
				</div>

				<div id="datasets-meta">
					<div className="card">
						<h3>Sorting</h3>
						<select
							value={this.state.sort}
							onChange={e =>
								this.setState({ sort: e.target.value })
							}
						>
							<option value="metadata_created">
								Creation Date
							</option>
							<option value="bibtex_year">Year</option>
							<option value="maintainers">Maintainer</option>
							<option value="title">Title</option>
						</select>
					</div>

					<div className="card">
						<h3>Projects</h3>
						<ul>
							<li
								className="project-filter"
								onClick={() => this.removeFilter("project")}
							>
								All
								<span className="project-count">
									{(this.props.datasets || []).length} items
								</span>
							</li>
							{Object.keys(projectCounts)
								.sort()
								.map(key => (
									<li
										key={key}
										className="project-filter"
										onClick={() =>
											this.toggleFilter("project", key)
										}
									>
										{key}
										<span className="project-count">
											{projectCounts[key]} items
										</span>
									</li>
								))}
						</ul>
					</div>

					<div className="card">
						<h3>Filters</h3>
						<ul className="badges">
							<li
								className="badge doi"
								onClick={() => this.toggleFilter("doi", true)}
							>
								DOI
							</li>
							<li
								className="badge sfbdoi"
								onClick={() =>
									this.toggleFilter("sfb806doi", true)
								}
							>
								SFB806DOI
							</li>
							<li
								className="badge spatial"
								onClick={() =>
									this.toggleFilter("spatial", true)
								}
							>
								Spatial
							</li>
							<li
								className="badge temporal"
								onClick={() =>
									this.toggleFilter("temporal", true)
								}
							>
								Temporal
							</li>
							<li
								className="badge paleomaps"
								onClick={() =>
									this.toggleFilter("paleomaps", true)
								}
							>
								PaleoMaps
							</li>
							<li
								className="badge peerreviewed"
								onClick={() =>
									this.toggleFilter("peerreviewed", true)
								}
							>
								Peerreviewed
							</li>
							<li
								className="badge peerreviewed"
								onClick={() =>
									this.toggleFilter(
										"peerreviewed",
										"ISI-indexed"
									)
								}
							>
								Peerreviewed + ISI Indexed
							</li>
						</ul>
					</div>

					<div className="card">
						<h3>Location (filter by map extend)</h3>
						<div
							className={
								"spatial" in filters &&
								typeof filters.spatial === "string"
									? "active-map"
									: ""
							}
						>
							<Map
								onMove={ev => {
									const bounds = ev.target.getBounds()
									this.toggleFilter(
										"spatial",
										JSON.stringify({
											x1: bounds.getWest().toFixed(2),
											x2: bounds.getEast().toFixed(2),
											y1: bounds.getSouth().toFixed(2),
											y2: bounds.getNorth().toFixed(2)
										})
									)
								}}
							/>
						</div>
					</div>

					<div className="card">
						<h3>Time</h3>
						<div className="form-row">
							<label>Presets</label>
							<select
								onChange={ev => {
									const [start, end] = ev.target.value.split(
										"-"
									)
									const filters = {
										...this.state.filters,
										["temporal-start"]: start,
										["temporal-end"]: end
									}
									setParams(filters)
									this.setState({
										filters,
										page: 1
									})
								}}
							>
								{temporalPresets.map(preset => (
									<option
										key={preset.label}
										value={preset.value}
									>
										{preset.label}
									</option>
								))}
							</select>
						</div>

						<div
							style={{
								display: "flex",
								marginTop: "1rem",
								justifyContent: "space-between"
							}}
						>
							<div className="form-row" style={{ width: "48%" }}>
								<label>Start (y.B.P.)</label>
								<input
									type="text"
									value={filters["temporal-start"] || ""}
									onChange={ev =>
										this.toggleFilter(
											"temporal-start",
											ev.target.value
										)
									}
								/>
							</div>

							<div
								className="form-row"
								style={{ width: "50%", marginTop: 0 }}
							>
								<label>End (y.B.P.)</label>
								<input
									type="text"
									value={filters["temporal-end"] || ""}
									onChange={ev =>
										this.toggleFilter(
											"temporal-end",
											ev.target.value
										)
									}
								/>
							</div>
						</div>
					</div>

					<div className="card tag-filter">
						<h3>Tags</h3>
						<input
							type="search"
							placeholder="Filter Tags"
							value={tagSearch}
							onChange={ev =>
								this.setState({
									tagSearch: ev.target.value.trim()
								})
							}
						/>
						<ul>
							{tags
								.filter(
									tag =>
										tagSearch.length < 1 ||
										tag
											.toLowerCase()
											.includes(tagSearch.toLowerCase())
								)
								.map(tag => (
									<li
										key={tag}
										onClick={() =>
											this.toggleFilter("tag", tag)
										}
									>
										{tag}
									</li>
								))}
						</ul>
					</div>
				</div>
			</div>
		)
	}
}

export default withRouteData(Datasets)



// WEBPACK FOOTER //
// /home/christian/git/pwa-crc806db/src/containers/Datasets/index.js